import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const deleteModelsStatusSelector = (state: State) =>
  state.deleteModels.status;
export const deleteModelsErrorSelector = (state: State) =>
  state.deleteModels.error;
export const deleteModelsLoadedSelector = isLoaded(deleteModelsStatusSelector);
export const deleteModelsPendingSelector = isPending(
  deleteModelsStatusSelector,
);
export const shouldDeleteModelsSelector = shouldLoad(
  deleteModelsStatusSelector,
);
export const deleteModelsRejectedSelector = isRejected(
  deleteModelsStatusSelector,
);
